import StyleOutlinedIcon from "@mui/icons-material/StyleOutlined";

import { RobotoIconButton, RobotoTooltip } from "@/shared/components";
import { FileDetailsDialog } from "@/shared/components/FileDetails/FileDetailsDialog";
import { FileRecord } from "@/shared/domain/files";
import { usePopupState } from "@/shared/hooks";

interface ViewFileDetailsButtonProps {
  fileRecord: FileRecord;
}

export function ViewFileDetailsButton({
  fileRecord,
}: ViewFileDetailsButtonProps) {
  const tagMetadataPopup = usePopupState();

  return (
    <>
      <RobotoTooltip title="View file details">
        <span>
          <RobotoIconButton
            eventName="FileDetailsClicked"
            onClick={() => tagMetadataPopup.open()}
            sx={{ padding: "0.5rem" }}
            size="small"
          >
            <StyleOutlinedIcon
              style={{
                width: "1.25rem",
                height: "1.25rem",
              }}
            />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>
      <FileDetailsDialog
        open={tagMetadataPopup.isOpen}
        onClose={tagMetadataPopup.close}
        fileRecord={fileRecord}
      />
    </>
  );
}
